module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/db-1200@2x-7da70c7735b3b66fb67e0382c3135afe.jpg";